import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { NgpLabelValue } from '../../../form/NgpLabelValue';
import {
    IPADDRESS_FIELD,
    IPADDRESSES_FIELD,
    LABEL_IP_ADDRESS,
    LABEL_IP_ADDRESSES,
    LABEL_NAME,
    LABEL_SITES,
    LABEL_TECHNOLOGY,
    LABEL_TOTAL_ENTITIES,
    LABEL_VENDOR,
    LABEL_VERSION,
    LABEL_VIRTUAL_TYPE,
    NAME_FIELD,
    SUBTYPE_FIELD,
    TECHNOLOGY_FIELD,
    VENDOR_FIELD,
    VERSION_FIELD,
} from '../InfrastructureConstants';
import { serverSubTypeFormatter } from '../InfrastructureFormatters';
import SitesLink from '../SitesLink';
import TotalEntitiesFieldValue from './TotalEntitiesFieldValue';
import PropertiesGrid, { PropertiesGridFullWidth } from '../../../form/PropertiesGrid';
import { EMPTY_IP_VALUE, getFieldValue, safeFormat, usePropertyValues } from '../InfrastructurePropertiesUtils';
import PropertiesIpAddressList from '../../../properties/PropertiesIpAddressList';

/**
 * Displays vCenter properties in label-value pairs
 * Shows vCenter details, version info, and related infrastructure links
 */
const VcenterProperties = () => {
    const extractPropertyValues = useCallback(
        (formData) => ({
            name: getFieldValue(formData, NAME_FIELD),
            ipAddress: getFieldValue(formData, IPADDRESS_FIELD),
            ipAddresses: getFieldValue(formData, IPADDRESSES_FIELD),
            virtualType: safeFormat(serverSubTypeFormatter, getFieldValue(formData, SUBTYPE_FIELD)),
            vendor: getFieldValue(formData, VENDOR_FIELD),
            technology: getFieldValue(formData, TECHNOLOGY_FIELD),
            version: getFieldValue(formData, VERSION_FIELD),
        }),
        []
    );

    const props = usePropertyValues(extractPropertyValues);

    return (
        <PropertiesGrid>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_NAME} dataValue={props.name} />
            </PropertiesGridFullWidth>
            <NgpLabelValue dataLabel={LABEL_IP_ADDRESS} dataValue={props.ipAddress} />
            <NgpLabelValue dataLabel={LABEL_TOTAL_ENTITIES} dataValue={<TotalEntitiesFieldValue />} />
            <NgpLabelValue dataLabel={LABEL_VIRTUAL_TYPE} dataValue={props.virtualType} />
            <NgpLabelValue dataLabel={LABEL_VENDOR} dataValue={props.vendor} />
            <NgpLabelValue dataLabel={LABEL_TECHNOLOGY} dataValue={props.technology} />
            <NgpLabelValue dataLabel={LABEL_VERSION} dataValue={props.version} />
            <NgpLabelValue dataLabel={LABEL_SITES} dataValue={<SitesLink />} />
            <NgpLabelValue
                dataLabel={LABEL_IP_ADDRESSES}
                dataValue={
                    isEmpty(props.ipAddresses) ? EMPTY_IP_VALUE : <PropertiesIpAddressList value={props.ipAddresses} />
                }
            />
        </PropertiesGrid>
    );
};

export default VcenterProperties;
